<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { MeetingEntry } from '@/graphql/custom-types';
import AgendaOverlay from '@/views/meetings/AgendaOverlay.vue';
import { ref } from 'vue';

const showAgendaOverlay = ref<boolean>(false);

interface Props {
  meeting: MeetingEntry;
}

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <div>
    <BasicBlock
      :icon="['fal', 'list']"
      canTriggerOverlay
      @click="showAgendaOverlay = true"
    >
      <p
        class="flex-1"
        :aria-label="
          $t('meeting.agendaPointss_plural', {
            amount: meeting.agendaPoints?.length || 0,
          })
        "
      >
        {{
          $t('meeting.agendaPointss_plural', {
            amount: meeting.agendaPoints?.length || 0,
          })
        }}
      </p>
    </BasicBlock>
  </div>

  <AgendaOverlay
    v-if="showAgendaOverlay"
    :items="meeting.agendaPoints || []"
    @close="showAgendaOverlay = false"
  />
</template>
